import React, { useEffect, useRef, useState, useCallback } from 'react'
// import { AccountSchema } from '../../data/types'
// import { LoginProps } from '../../data/types'
import signinBgPhoto from "../../assets/img/signinBgPhoto.jpg";
// import homecook_logo from '../../assets/img/homecook_logo.png'
// import LoadingScreen from '../shared/LoadingScreen';
// import LoadingComponent from '../../components/LoadingComponent';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useManageTeam } from '../../hooks/communityhook';
import {toast} from 'sonner';


const getEmailFromToken = (token: string) => {
    if (token){
        var user = JSON.parse(atob(token.split('.')[1]))
        return user.hasOwnProperty('email') && user.hasOwnProperty('exp') ? user.email : ""
    }
    return ""
}


const getCommunityIdFromToken = (token: string) => {
    if (token){
        var user = JSON.parse(atob(token.split('.')[1]))
        return user.hasOwnProperty('community_id') && user.hasOwnProperty('exp') ? user.community_id : ""
    }
    return ""
}


const VerifyEmail = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    // const emailParam = searchParams.get('email')
    const token = searchParams.get('token')
    // console.log("emailParam", emailParam)
    // console.log("tokenParam", tokenParam)
    // const [email, updateEmail] = useState(emailParam || '')
    // let { 
    //     registerUser, 
    //     toggleSignUp,
    //     // togglePhone 
    // }: LoginProps = {}


    const { verifyUserEmail } = useManageTeam()
    const hasVerifiedRef = useRef(false)

    // console.log("searchParams", searchParams)

    const handleEmailVerification = useCallback(async (token: string) => {
        if (hasVerifiedRef.current) return
        hasVerifiedRef.current = true
        try {
            const primaryCommunityId = getCommunityIdFromToken(token)
            const email = getEmailFromToken(token)
            const result = await verifyUserEmail({primaryCommunityId, email, token})
            if (result){
                toast.success('Invitation accepted successfully, continue to login', { position: 'top-center' })
                setTimeout(()=> {
                navigate('/login')
                }, 3000)
            } else {
                toast.error('Invitation link is not valid', { position: 'top-center' })
            }
        } catch (error) {
            console.error('Link is not valid:', error)
            toast.error('Link is not valid', { position: 'top-center' })
        }
    }, [verifyUserEmail, navigate])

    // const isValidEmail = (email: string): boolean => {
    //     const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/ // Regular expression for a simple email validation
    //     return emailRegex.test(email) // Testing the email against the regex
    // }

    // const handleChange = (e: React.ChangeEvent<HTMLInputElement>, field: string) => {
    //     if (field === 'email' && (e.target.value || e.target.value  === "")){
    //             e.preventDefault()
    //             updateEmail(e.target.value.toLowerCase())
    //         }
    // }



    // const goToOTP = async () => {
    //     if (email && registerUser !== undefined){
    //         // let phone = ""
    //         var user_to_register: AccountSchema = {email}
    //         // console.log("email", email)
    //         registerUser(user_to_register)
    //     }
    // }

    const [isBeta, setIsBeta] = useState(false);


    useEffect(()=> {
        document.title = 'Verify Email | HomeCook'
        const checkBetaInURL = () => {
            const currentURL = window.location.href.toLowerCase();
            return currentURL.includes('beta') || currentURL.includes('localhost') || currentURL.includes('homecook.space');
        };
        setIsBeta(checkBetaInURL());

        if (token) {
            handleEmailVerification(token)
        }
     }, [token, handleEmailVerification])
  return (
    <div className='flex w-screen mx-auto p-auto items-start justify-evenly h-[900px] sm:h-screen overflow-y-scroll 
    before:bg-white/[95%] 
    bg-cover 
    bg-center 
    bg-no-repeat 
    before:content-[""] 
    before:absolute 
    before:inset-0 
    md:relative
    relative'
>
    {/* Add Beta Tag */}
    {
       (isBeta) && (<div className="absolute top-4 left-4 z-50 flex items-center gap-1 bg-gradient-to-r from-primary-400 to-primary-300 text-white px-2 py-0.5 rounded-full shadow-lg animate-pulse">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
                <path d="M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zM12 2a1 1 0 01.967.744L14.146 7.2 17.5 9.134a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0L9.854 12.8 6.5 10.866a1 1 0 010-1.732l3.354-1.935 1.18-4.455A1 1 0 0112 2z" />
            </svg>
            <span className="font-medium text-xs tracking-wide font-open-sans ">BETA</span>
        </div>)
    }
    <img src={signinBgPhoto} alt="Sign In" className="absolute inset-0 z-[-1] object-cover w-full h-full" />
    {/* <div className="relative mx-auto mt-24 w-full">
        <div className="flex flex-col justify-evenly align-middle sm:w-1/4 border-[#E9E9E9] border-[1px] p-6 rounded-lg bg-white/80 mx-auto">
            <img src={ homecook_logo} alt="HomeCook" className='w-[100px] mx-auto cursor-pointer' onClick={()=> null} />
            <h4 className="font-raleway text-center m-[1%] text-[22px] text-black font-semibold">Verify your email</h4>
            <div className="text-[16px] text-primary-300 text-center w-11/12 mx-auto font-open-sans ">
                <LoadingComponent bgColor="white" height="10px" fillColor="yellow-400" /> 
                <span className="text-yellow-600 mt-[10px] font-raleway font-semibold">Verifying your account</span>
            </div>
        </div>
   </div> */}
</div>
  )
}

export default VerifyEmail  